// List of pages where we should disable custom react scroll
export const PAGES_WITHOUT_SCROLL = [
  'main.logged.sites',
  'main.logged.payment.initialDomains',
  'main.logged.user-management.config-sites',
  'main.logged.payment.activeSitesCm',
  'main.logged.payment.activeSitesCb',
  'main.logged.live-site-translations.sites',
];
